import { cognito } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import * as LS from 'helpers/localStorage';
import { call, put, select } from 'redux-saga/effects';
import { ApiStateData, AuthData, MakerSelectors } from 'types';

import { authMigration } from './authMigration';
import { baseConfig } from './baseConfig';

type Data = AuthData;

type Payload = {
  email: string;
  password: string;
  keepSession: boolean;
};

interface ExtraSelectors extends MakerSelectors<ApiStateData<Data>> {
  getIsSupport: (d: ApiStateData<Data>) => boolean;
  getKeepSession: (d: ApiStateData<Data>) => boolean;
  getNeedNewPassword: (d: ApiStateData<Data>) => boolean;
}

export const authSignIn = createApiSlice<Data, Payload, ExtraSelectors>({
  name: 'authSignIn',
  *tryGenerator(_, { payload: { email, password, keepSession } }) {
    const data: AuthData = yield call(cognito.signIn, { email, password });
    // const isProd: boolean = yield select(baseConfig.selectors.getIsProdBackend);

    const fullData: AuthData = { ...data, keepSession };

    /**
     * Call to migrate auth system (temporary)
     *
     

    if (isProd) {
      const { username } = data;
      yield put(authMigration.actions.call({ email, password, username }));
    }
    */

    /**
     * Save authData to local Storage
     */
    LS.updateField({ field: 'authSignIn', data: fullData });

    return fullData;
  },
  extraSelectors: {
    getIsSupport: (data) => !!data?.signInUserSession?.accessToken?.payload?.['cognito:groups'],
    getKeepSession: (data) => !!data?.keepSession,
    getNeedNewPassword: (data) => data?.challengeName === 'NEW_PASSWORD_REQUIRED',
  },
});
